if (!customElements.get('drawer-component')) {

  class DrawerComponent extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();

      this.openOnArrival();

    }

    openOnArrival() {

      const params = new URL(document.location).searchParams;
      const redirect = params.get('opencart') == 1;

      if (redirect) {
        this.open();
      }

    }

    setHeaderCartIconAccessibility() {
      const triggerLink = document.getElementById(this.dataset.triggerId);

      if (triggerLink) {
        triggerLink.setAttribute('role', 'button');
        triggerLink.setAttribute('aria-haspopup', 'dialog');
        triggerLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(triggerLink);
        });
        triggerLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(triggerLink);
          }
        });
      }
    }

    open(triggeredBy) {

      if (triggeredBy) this.setActiveElement(triggeredBy);

      // this.classList.add("animate", "active");
      // document.body.classList.add('overflow-hidden');

      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');

      // Q: This comment below is the Blend developer trying to figure out the issue with the cart.
      // they are overwriting the cart when they fetch the cart, and it's not populated in time, so they tried a timeout:
      // I fixed this by just opening the cart instead of waiting, and then put a return statement before the rest of the code because it was breaking the Safari experience entirely.

      // here the animation doesn't seem to always get triggered. A timeout seem to help

      // setTimeout(() => {
      //   this.classList.add('animate', 'active');
      //   document.body.classList.add('overflow-hidden');
      // });

      return;

      // Everything after this point is bad Blend code that doesn't do what it should anyway and breaks Safari.

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : this.querySelector('.drawer-component');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {

      this.classList.remove("animate", 'active');
      document.body.classList.remove('overflow-hidden');

      return;

      // Everything after this point is bad Blend code that doesn't do what it should anyway and breaks Safari.

      removeTrapFocus(this.activeElement);

      clearTimeout(this.timeout);
      
      this.timeout = setTimeout(() => {
        document.body.classList.remove('overflow-hidden');
      }, getComputedStyle(document.querySelector(':root')).getPropertyValue('--duration-default').replace('s', '') * 1000);

    }

    setActiveElement(element) {
      this.activeElement = element;
    }
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer .drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    renderContents(parsedState) {

      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {

        const sectionId = section.id;
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(sectionId);
        const content = this.getSectionInnerHTML(parsedState.sections[sectionId], section.selector);

        sectionElement.innerHTML = content;

      });

    }

  }

  customElements.define('drawer-component', DrawerComponent);

  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}